import * as angular from 'angular';
import { consolePrint } from '../../common/events';
import { ComponentDefinition } from '../../models';

class ConsoleController implements angular.IComponentController {
    static controllerId: string = 'Console';
    consoleOutput: string;
    ctrl: Object;
    rows = 9;
    static $inject = ['$scope'];

    constructor(private _$scope: angular.IScope) {
    }

    $onInit() {
        this.consoleOutput = '';
        this._$scope.$on(consolePrint, (event, data) => {
            this.consoleOutput = `${data.message}\n`;
        });

        const self = this;
        this.ctrl = {
            clear: () => { self.consoleOutput = ''; }
        };
    }
}

export const wtConsole: ComponentDefinition = {
    componentId: 'wtConsole',
    controller: ConsoleController,
    template: require('./console.component.html'),
    controllerAs: 'vm',
    bindings: {
        item: '=',
        ctrl: '=',
        rows: '@'
    }
};
